export function formatTimeZone(): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const city = timeZone.split("/").pop()?.replaceAll("_", " ");
  const offsetHours = -new Date().getTimezoneOffset() / 60;
  const offset = offsetHours >= 0 ? `+${offsetHours}` : `${offsetHours}`;

  return `GMT${offset} (${city})`;
}
